import { ArrowUpRight } from "lucide-react";
import { PageHero } from "../components/PageHero";
import { Reveal, StarDivider } from "../components/Motion";
import { Star } from "../components/brand/Logo";
import { CtaBand } from "../components/CtaBand";
import { useLang } from "../i18n/LangContext";

const CaseStudy = ({ p, i, t }) => (
  <article id={p.slug} className="scroll-mt-28 py-16 md:py-24" data-testid={`case-study-${p.slug}`}>
    <div className="grid gap-12 lg:grid-cols-12">
      <Reveal className={`lg:col-span-7 ${i % 2 ? "lg:order-2" : ""}`}>
        <div className="overflow-hidden rounded-sm border border-white/10 bg-char">
          <div className="flex items-center gap-2 border-b border-white/10 px-4 py-3">
            <span className="h-2 w-2 rounded-full bg-white/20" /><span className="h-2 w-2 rounded-full bg-white/20" /><span className="h-2 w-2 rounded-full bg-lav" />
            <span className="label ml-4 text-[10px] text-mist">{p.url.replace(/https:\/\/(www\.)?/, "").replace(/\/$/, "")}</span>
          </div>
          <img src={p.img} alt={`${p.name}: ${t.a11y.liveSite}`} className="w-full" loading="lazy" />
        </div>
      </Reveal>
      <div className={`flex flex-col justify-center lg:col-span-5 ${i % 2 ? "lg:order-1" : ""}`}>
        <Reveal>
          <p className="label text-lav">0{i + 1} / {p.meta}</p>
          <h2 className="mt-5 font-display text-5xl font-extrabold uppercase leading-[0.9] tracking-tight text-ivory md:text-6xl">{p.name}</h2>
          <p className="mt-6 leading-relaxed text-ivory/75">{p.summary}</p>
          <p className="label mt-10 text-mist">{t.work.built}</p>
          <ul className="mt-5 space-y-3">
            {p.points.map((pt) => (
              <li key={pt} className="flex gap-3 text-sm text-ivory/85"><Star className="mt-1 h-3 w-3 shrink-0 text-lav" />{pt}</li>
            ))}
          </ul>
          <a href={p.url} target="_blank" rel="noopener noreferrer" data-testid={`visit-site-${p.slug}`}
            className="label group mt-10 inline-flex items-center gap-3 rounded-full border border-lav px-6 py-4 text-ivory transition-colors duration-300 hover:bg-lav hover:text-ink">
            {t.work.visit}<ArrowUpRight className="h-4 w-4 transition-transform group-hover:rotate-45" />
          </a>
        </Reveal>
      </div>
    </div>
  </article>
);

export default function Work() {
  const { t } = useLang();
  return (
    <>
      <PageHero testid="work-hero" label={t.work.label} lines={t.work.pageTitle} accentLine={1} sub={t.work.pageSub} />
      <div className="mx-auto max-w-[1440px] px-5 md:px-10">
        {t.work.projects.map((p, i) => (
          <div key={p.slug}>
            <StarDivider />
            <CaseStudy p={p} i={i} t={t} />
          </div>
        ))}
        <StarDivider />
        <p className="py-20 text-center font-display text-3xl font-semibold uppercase tracking-tight text-ivory/40 md:text-5xl" data-testid="work-next-project">{t.work.more}</p>
      </div>
      <CtaBand />
    </>
  );
}
